import { useUserStore } from '@/stores/user'

function redirectIfNotVector() {
  const user = useUserStore()
  if (user.data?.access?.vector !== true)
    window.location.href = import.meta.env.VITE_APP_URL
}

const providers = [
  {
    path: '/vector/providers',
    name: 'vector-providers-home',
    component: () => import('@/pages/vector/providers/ProvidersListPage.vue'),
    meta: {
      title: 'Providers',
      resource: 'Vector',
      action: 'read',
      subject: 'Provider',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/providers/new',
    name: 'vector-providers-new',
    component: () => import('@/pages/vector/providers/NewProviderPage.vue'),
    meta: {
      title: 'New Provider',
      resource: 'Vector',
      action: 'create',
      subject: 'Provider',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/providers/:provider_uuid',
    name: 'vector-providers-provider-details',
    component: () => import('@/pages/vector/providers/ProviderDetailPage.vue'),
    meta: {
      title: 'Provider Detail',
      resource: 'Vector',
      action: 'read',
      subject: 'Provider',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/providers/:provider_uuid/users',
    name: 'vector-provider-users',
    component: () => import('@/pages/vector/providers/ProviderUsersPage.vue'),
    meta: {
      title: 'Provider Users',
      resource: 'Vector',
      action: 'read',
      subject: 'Provider',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/providers/:provider_uuid/upload-configs/:config_uuid',
    redirect: to => ({
      name: 'vector-admin-tools-upload-configs-detail',
      params: { config_uuid: to.params.config_uuid },
    }),
  },
]

export default providers
